import React from "react";
import LayoutHeader from "../common/LayoutHeader";
import Footer from "../common/LayoutFooter";
import splashImg from "../../assets/images/hype_na_splash.png";

const AppLanding = () => {
  return (
    <>
      <LayoutHeader />
      <div className="hn-section">
        <div className="container">
          <div className="row align-items-center">
             <div className="col-lg-6 mb-5 mb-lg-0">
               <span className="hn-card-badge mb-2">Mobile App</span>
               <h1 className="hn-section-title">Get the HypeNa App</h1>
               <p className="lead">Experience the best of Namibian events and competitions right from your pocket.</p>
               <p>
                 Download our mobile application to stay updated with the latest events, 
                 participate in competitions, and book services directly from your phone.
                 Available now for iOS and Android.
               </p>
               <div className="d-flex" style={{ gap: '15px', marginTop: '30px' }}>
                 <a 
                   href="https://apps.apple.com/na/app/hypena/id6503223963"
                   target="_blank"
                   rel="noopener noreferrer"
                   className="primary-btn-fill text-decoration-none"
                 >
                    <i className="bi bi-phone" /> App Store
                 </a>
                 <a 
                   href="https://play.google.com/store/apps/details?id=com.na.hypena"
                   target="_blank"
                   rel="noopener noreferrer"
                   className="primary-btn-fill text-decoration-none"
                 >
                    <i className="bi bi-google" /> Google Play
                 </a>
               </div>
             </div>
             <div className="col-lg-6 text-center">
               <img 
                 src={splashImg} 
                 alt="HypeNa App Splash" 
                 className="img-fluid shadow-lg" 
                 style={{ maxHeight: '600px', borderRadius: '1.5rem', objectFit: 'cover' }} 
               />
             </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AppLanding;